var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.54,37.28H22.43l-0.02-0.13c-1.61-8.34-1.61-16.91,0-25.25l0.02-0.13h12.11c6.97,0,12.62,5.65,12.62,12.62 v0.26C47.16,31.63,41.51,37.28,34.54,37.28z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.12,22.39H2.63c-1.18,0-1.8,1.07-1.8,2.14s0.62,2.14,1.8,2.14h14.49c1.18,0,1.8-1.07,1.8-2.14 S18.3,22.39,17.12,22.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.63,20.64h14.49c1.18,0,1.8-1.07,1.8-2.14c0-1.06-0.62-2.14-1.8-2.14H2.63c-1.18,0-1.8,1.07-1.8,2.14 C0.84,19.57,1.45,20.64,2.63,20.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.12,28.42H2.63c-1.18,0-1.8,1.07-1.8,2.14c0,1.06,0.62,2.14,1.8,2.14h14.49c1.18,0,1.8-1.07,1.8-2.14 C18.91,29.49,18.3,28.42,17.12,28.42z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.6b99d27e68a7b71fcce3c5036ba460b4.svg";
export { ForwardRef as ReactComponent };